import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconGooglePlay = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 108 26" {...props}>
    <path
      fill="#fff"
      d="M34.91 3.44c0 .769-.234 1.385-.693 1.844-.528.545-1.215.819-2.058.819a2.845 2.845 0 01-2.056-.828c-.566-.557-.848-1.242-.848-2.06 0-.82.282-1.503.848-2.056a2.83 2.83 0 012.056-.833c.401 0 .783.082 1.148.234.364.153.66.36.874.616l-.487.486c-.374-.436-.883-.652-1.535-.652a2.15 2.15 0 00-1.529.612c-.427.41-.642.94-.642 1.593 0 .651.215 1.187.642 1.597a2.17 2.17 0 001.53.611c.623 0 1.147-.207 1.56-.616.273-.27.428-.643.47-1.12h-2.03V3.02h2.708c.032.144.041.283.041.418zM39.208 1.132h-2.544v1.75h2.293v.666h-2.293v1.75h2.544v.679h-3.264V.454h3.264v.678zM42.24 5.977h-.721V1.132h-1.56V.454H43.8v.678h-1.562v4.845zM46.58 5.977V.454h.964v5.523h-.964zM50.486 5.977h-.714V1.132h-1.567V.453h3.847v.679h-1.566v4.845zM59.328 5.266c-.551.558-1.234.837-2.048.837-.82 0-1.502-.279-2.054-.837-.55-.558-.824-1.242-.824-2.051 0-.81.274-1.494.824-2.051.552-.559 1.234-.838 2.054-.838.81 0 1.492.279 2.044.842.554.562.828 1.242.828 2.047 0 .81-.274 1.493-.824 2.05zm-3.57-.463c.416.413.92.62 1.522.62.596 0 1.105-.207 1.516-.62.413-.414.623-.945.623-1.588 0-.644-.21-1.175-.623-1.588-.41-.414-.92-.621-1.516-.621a2.07 2.07 0 00-1.521.62c-.414.414-.624.945-.624 1.589 0 .643.21 1.174.624 1.588zM61.161 5.977V.454h.874l2.718 4.295h.031l-.031-1.062V.454h.719v5.523h-.75l-2.846-4.508h-.032l.032 1.067v3.44h-.715zM54.224 14.042c-2.19 0-3.978 1.647-3.978 3.92 0 2.253 1.788 3.917 3.978 3.917 2.194 0 3.983-1.664 3.983-3.918 0-2.272-1.789-3.919-3.983-3.919zm0 6.294c-1.201 0-2.235-.98-2.235-2.374 0-1.414 1.034-2.376 2.235-2.376 1.202 0 2.24.962 2.24 2.376 0 1.394-1.038 2.374-2.24 2.374zm-8.68-6.294c-2.194 0-3.979 1.647-3.979 3.92 0 2.253 1.785 3.917 3.979 3.917 2.193 0 3.978-1.664 3.978-3.918 0-2.272-1.785-3.919-3.978-3.919zm0 6.294c-1.203 0-2.24-.98-2.24-2.374 0-1.414 1.037-2.376 2.24-2.376 1.201 0 2.235.962 2.235 2.376 0 1.394-1.034 2.374-2.235 2.374zm-10.33-5.092v1.665h4.024c-.117.93-.432 1.614-.914 2.091-.588.576-1.503 1.215-3.11 1.215a4.392 4.392 0 01-4.415-4.422 4.392 4.392 0 014.415-4.422c1.34 0 2.314.517 3.033 1.187l1.187-1.174c-1.006-.949-2.343-1.678-4.22-1.678-3.395 0-6.25 2.731-6.25 6.087s2.855 6.086 6.25 6.086c1.836 0 3.214-.594 4.298-1.709 1.11-1.097 1.457-2.64 1.457-3.886 0-.387-.033-.743-.091-1.04h-5.664zm42.238 1.29c-.327-.876-1.337-2.492-3.395-2.492-2.04 0-3.737 1.589-3.737 3.92 0 2.195 1.68 3.917 3.932 3.917a3.942 3.942 0 003.305-1.736l-1.352-.89c-.45.651-1.065 1.083-1.953 1.083-.882 0-1.514-.4-1.92-1.187l5.303-2.169-.183-.445zm-5.407 1.305c-.045-1.51 1.188-2.284 2.071-2.284.692 0 1.28.342 1.475.831l-3.546 1.453zm-4.31 3.802h1.743V10.125h-1.743V21.64zm-2.855-6.726h-.058c-.392-.458-1.139-.873-2.085-.873-1.986 0-3.802 1.723-3.802 3.932 0 2.196 1.816 3.905 3.802 3.905.946 0 1.693-.418 2.084-.89h.059v.562c0 1.498-.81 2.304-2.116 2.304-1.066 0-1.726-.76-1.999-1.4l-1.516.626c.437 1.038 1.594 2.317 3.515 2.317 2.044 0 3.768-1.189 3.768-4.08V14.28H64.88v.634zm-1.994 5.421c-1.202 0-2.207-.994-2.207-2.362 0-1.38 1.005-2.388 2.207-2.388 1.184 0 2.117 1.007 2.117 2.388 0 1.368-.933 2.362-2.117 2.362zm22.728-10.211h-4.17V21.64h1.74v-4.364h2.43c1.931 0 3.825-1.38 3.825-3.577 0-2.195-1.898-3.575-3.825-3.575zm.046 5.55h-2.477v-3.949h2.477a2.01 2.01 0 012.039 1.974c0 .892-.741 1.976-2.04 1.976zm10.747-1.654c-1.256 0-2.562.548-3.1 1.763l1.543.639c.333-.64.943-.847 1.589-.847.902 0 1.817.536 1.83 1.482v.12c-.314-.18-.988-.445-1.816-.445-1.662 0-3.355.904-3.355 2.59 0 1.544 1.36 2.538 2.891 2.538 1.17 0 1.816-.522 2.221-1.129h.06v.89h1.679v-4.417c0-2.042-1.543-3.184-3.542-3.184zm-.21 6.31c-.568 0-1.36-.278-1.36-.975 0-.891.988-1.233 1.843-1.233.766 0 1.124.167 1.59.387a2.102 2.102 0 01-2.072 1.822zm9.87-6.058l-1.999 4.992h-.059l-2.066-4.992h-1.875l3.104 6.977-1.771 3.882h1.816l4.784-10.86h-1.934zM90.394 21.64h1.744V10.125h-1.744V21.64z"
    />
    <path
      fill="url(#paint0_linear_1436_31464)"
      d="M.432.947C.158 1.231 0 1.672 0 2.243v20.375c0 .571.158 1.012.432 1.296l.068.062 11.553-11.413v-.27L.5.881.432.947z"
    />
    <path
      fill="url(#paint1_linear_1436_31464)"
      d="M15.901 16.368l-3.846-3.806v-.27l3.851-3.806.086.05 4.561 2.565c1.302.727 1.302 1.925 0 2.658l-4.56 2.56-.092.05z"
    />
    <path
      fill="url(#paint2_linear_1436_31464)"
      d="M15.992 16.318l-3.938-3.891L.434 23.912c.432.45 1.137.504 1.939.055l13.619-7.649z"
    />
    <path
      fill="url(#paint3_linear_1436_31464)"
      d="M15.992 8.536L2.372.888C1.572.444.867.498.435.948l11.62 11.48 3.938-3.892z"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1436_31464"
        x1="7.388"
        x2="-2.498"
        y1="22.83"
        y2="13.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF"></stop>
        <stop offset="0.007" stopColor="#00A1FF"></stop>
        <stop offset="0.26" stopColor="#00BEFF"></stop>
        <stop offset="0.512" stopColor="#00D2FF"></stop>
        <stop offset="0.76" stopColor="#00DFFF"></stop>
        <stop offset="1" stopColor="#00E3FF"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_1436_31464"
        x1="22.248"
        x2="-0.309"
        y1="12.426"
        y2="12.426"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000"></stop>
        <stop offset="0.409" stopColor="#FFBD00"></stop>
        <stop offset="0.775" stopColor="orange"></stop>
        <stop offset="1" stopColor="#FF9C00"></stop>
      </linearGradient>
      <linearGradient
        id="paint2_linear_1436_31464"
        x1="13.851"
        x2="-2.965"
        y1="13.687"
        y2="-2.931"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44"></stop>
        <stop offset="1" stopColor="#C31162"></stop>
      </linearGradient>
      <linearGradient
        id="paint3_linear_1436_31464"
        x1="-2.492"
        x2="5.016"
        y1="20.528"
        y2="13.109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071"></stop>
        <stop offset="0.069" stopColor="#2DA771"></stop>
        <stop offset="0.476" stopColor="#15CF74"></stop>
        <stop offset="0.801" stopColor="#06E775"></stop>
        <stop offset="1" stopColor="#00F076"></stop>
      </linearGradient>
    </defs>
  </svg>
);

export default IconGooglePlay;
